module.exports = __webpack_public_path__ + "img/lb.51d86748.svg";